import Vue from "vue";
const vm = new Vue()
import moment from "moment";

export const dateLimitRanges = (event , date , formatDate = "YYYY-MM-DD") => {
    let minDate = null
    let maxDate = null
    
    if( vm.$USER_LOGIN.get().isShippop ){
        return { minDate: minDate, maxDate: moment().format(formatDate) }
    }

    if( event == 'startSelection' ){
        minDate = moment(date, formatDate).add(-1, 'months').format(formatDate)
        maxDate =  moment(date, formatDate).add(1, 'months').format(formatDate)
        if( moment(date, formatDate).add(1, 'months').valueOf() > moment().valueOf() ){
            maxDate = moment().format(formatDate);
        }
    }else if( event == 'finishSelection' ){
        minDate = null
        maxDate = moment().format(formatDate);
    }

    return { minDate: minDate, maxDate: maxDate }
};